import { PlayingLevel } from "../../../types/types/listing.types";

import axios from "../../axios";

type PlayingLevelResponse = {
  items: PlayingLevel[];
};

export const getPlayingLevels = async (): Promise<PlayingLevelResponse> => {
  const { data } = await axios.get<PlayingLevelResponse>("/lists/playingLevel/");
  return data;
};
